import { Redirect } from "react-router-dom";

import OrderPage from "../pages/JIFI/orders";
import OrderCreatePage from "../pages/JIFI/orders/create";
import AwaitingStock from "../pages/JIFI/orders/awaiting-stock";
import OrdersAll from "../pages/JIFI/orders/all";
import SkuHistoryPage from "../pages/JIFI/movement-history-sku";
import OrdersMonograms from "../pages/JIFI/orders/monograms";
import OrdersDaily from "../pages/JIFI/orders/daily";
import UnfulfilledWarehouseOrdersPage from "../pages/JIFI/orders/unfulfilled-warehouse";
import Products from "../pages/JIFI/products";
import Stock from "../pages/JIFI/stock";
import Approvals from "../pages/JIFI/approvals";
import ApprovalGroup from "../pages/JIFI/approval-group";
import Downloads from "../pages/JIFI/downloads";
import UserProfile from "../pages/JIFI/user/profile";
import UserEdit from "../pages/JIFI/user/all";
import VariantListPage from "../pages/JIFI/Products/variant/all";
import CorpOrdersAll from "../pages/JIFI/corp-orders/all";
import CorpOrder from "../pages/JIFI/corp-orders/index";

import SkuListPage from "../pages/JIFI/skumapping/all";
import Return from "../pages/JIFI/returns/index";
import AllReturns from "../pages/JIFI/returns/all";

import Embroidery from "../pages/JIFI/embroidery";
import Print from "../pages/JIFI/print";
import Pull from "../pages/JIFI/pull";
import PrintTest from "../pages/JIFI/testPrint";
import PrintLabels from "../pages/JIFI/print-labels";
import ForwardPrintLabels from "../pages/JIFI/forward-print-label";
import Transfer from "../pages/JIFI/transfer";

import ForcastMonths from '../pages/JIFI/forecast/months'
import ForecastPage from '../pages/JIFI/forecast/index'

import Deliveries from "../pages/JIFI/deliveries/list";
import Delivery from "../pages/JIFI/deliveries/index";
import DeliveryBatch from "../pages/JIFI/deliveries/batch-list";


import ExternalPersBatches from "../pages/JIFI/personalisation-batch/external-pers/batches";


import ExternalPersBatchesEWE from "../pages/JIFI/personalisation-batch/external-pers-ewe/batches";
import ExternalPersBatchesEWESYD from "../pages/JIFI/personalisation-batch/external-pers-ewe-syd/batches";


import ExternalPersBatchesAirbox from "../pages/JIFI/personalisation-batch/external-pers-airbox/batches";


import ExternalPersBatchesLaunch from "../pages/JIFI/personalisation-batch/external-pers-launch/batches";


import BookContainer from "../pages/JIFI/containers/createContainer";
import ListContainer from "../pages/JIFI/containers/listContainers";
import EditContainer from "../pages/JIFI/containers/editContainer";
import UpcomingContainer from "../pages/JIFI/containers/upcomingContainers";
import Container from "../pages/JIFI/containers/container";
import MovementPage from "../pages/JIFI/movement-history";
import DualInventoryPage from "../pages/JIFI/dual-inventory";

import AllStock from "../pages/JIFI/all-stock";
import AllStockNew from "../pages/JIFI/all-stock-new";
import LocationOrderConfig from "../pages/JIFI/location-order-config";
import StockWarning from "../pages/JIFI/stock-warnings";
import EizConsignment from "../pages/JIFI/eiz/all";

// Authentication related pages
import Login from "../pages/Skote/Authentication/Login";
import Logout from "../pages/Skote/Authentication/Logout";
import Register from "../pages/Skote/Authentication/Register";
import ForgetPwd from "../pages/Skote/Authentication/ForgetPassword";
import LockScreen from "../pages/Skote/AuthenticationInner/auth-lock-screen";

  // Dashboard
import Dashboard from "../pages/Skote/Dashboard/index";

//Pages
import PagesMaintenance from "../pages/Utility/pages-maintenance";
import PagesComingsoon from "../pages/Utility/pages-comingsoon";
import Pages404 from "../pages/Utility/pages-404";
import Pages500 from "../pages/Utility/pages-500";

import AllProducts from "../pages/JIFI/Products/all";
import EditProducts from "../pages/JIFI/Products/edit";
import EditVariant from "../pages/JIFI/Products/variant/variant";

import AllLocations from '../pages/JIFI/locations/all'
import EditLocations from '../pages/JIFI/locations/index'
import AssignSkuPage from '../pages/JIFI/location-hierarchy/AssignSkuPage'

import AllErrorLogs from '../pages/JIFI/error-logs/all'
import ErrorLogDetail from '../pages/JIFI/error-logs/index'
import AllFlagType from '../pages/JIFI/flagtype/all'
import EditFlagType from '../pages/JIFI/flagtype/index'

import BulkSendTo3PL from '../pages/JIFI/bulk-send'
import ParcelsPage from "../pages/JIFI/parcels";
import CogPage from '../pages/JIFI/cog'
// import StockOverTime from "../pages/JIFI/analytics/stockOverTime";
// import ProductOverTime from "../pages/JIFI/analytics/productsOverTime";
// import MonogramPerformance from "../pages/JIFI/analytics/monogramPerformance";
import Automations from "../pages/JIFI/automations/view-reccomendations";
import AutomationDashboardPage from "../pages/JIFI/automation-engine/pages/AutomationDashboardPage";
import RuleBuilderPage from "../pages/JIFI/automation-engine/pages/RuleBuilderPage";

import FactoryPage from "../pages/JIFI/factory/index";
import FactoryList from "../pages/JIFI/factory/list";
import TotalStockList from "../pages/JIFI/total-stock/list";
import ClosingSohList from "../pages/JIFI/total-stock/closing";
import CogsRateList from "../pages/JIFI/cogs/list";
import CogsHoldingList from "../pages/JIFI/cogs/holding";
import CogsBreakdown from "../pages/JIFI/cogs/breakdown";
import ContainerTimeline from "../pages/JIFI/containers/timeline";

import PurchaseOrderPage from "../pages/JIFI/purchase-orders/index";
import PurchaseOrderList from "../pages/JIFI/purchase-orders/list";
import VariantBulkEditor from "../pages/JIFI/Products/variant/variant-bulk-edit";
import TransferStockPage from "../pages/JIFI/stock/transfers";
import ReplenishStockPage from "../pages/JIFI/stock/replenish";
import ReturnToWarehousePage from "../pages/JIFI/stock/return-to-warehouse";
import StockStatus from "../pages/JIFI/demand/stock-status";
import StockStatusMonth from "../pages/JIFI/demand/stock-status-month";

import BulkSendEmbossing from "../pages/JIFI/bulk-send/embossing";
import HistoricAllocation from "../pages/JIFI/demand/historicAllocation";
import HistoricStockLevels from "../pages/JIFI/demand/historicStockLevels";
import WarehouseTransferPage from "../pages/JIFI/stock/warehouse-transfer";
import ReleasesSupplyChain from "../pages/JIFI/purchase-orders/releases";
import ReleasesSupplyChainList from "../pages/JIFI/purchase-orders/releases/list";
import BasicTable from "../pages/JIFI/purchase-orders/stockMovement";
import NotificationListPage from "../pages/JIFI/notifications";
import FulFillmentLocationPage from "../pages/JIFI/fulfillment-location";

import OrderTicketPage from "@pages/JIFI/order-ticket";
import FeedbackPage from "@pages/JIFI/order-ticket/feedback";
import WarrantyClaimPage from "@pages/JIFI/warranty-claim/warranty-claim";
import WarrantyKanbanBoard from "@pages/JIFI/warranty-claim";
import CategoryListPage from "@pages/JIFI/category/all";
import CategoryPage from "@pages/JIFI/category";
import MisPickStock from "@pages/JIFI/orders/mispick-stock";
import TicketsPage from "@pages/JIFI/tickets";
import RepairTicket from "@pages/JIFI/repair-ticket/repair-ticket";
import IpLogListPage from "@pages/JIFI/ip-logs/all";


import TicketDashboardPage from "@pages/JIFI/ticket-dashboard/pages/TicketDashboardPage";
import StatusMappingPage from "@pages/JIFI/ticket-dashboard/pages/StatusMappingPage";
import TrackingUpdatesPage from "@pages/JIFI/tracking-updates";
import InventoryAccuracyPage from '@pages/JIFI/jifi-metric/index.js'
import CarrierPerformanceList from "@pages/JIFI/carrier-performance/index.js";
import ShipmentAnalytic from "@pages/JIFI/shipment-analytic/index.js";
import StockoutReport from '@pages/JIFI/stockout-report/index.js'
import ForecastMonthStock from '@pages/JIFI/forecast-month-stock/index.js'
import RegionConfigsPage from "../pages/region-configs";
import RegionConfigDetail from "../pages/region-configs/RegionConfigDetail";
import AmazonSellerConfigsPage from "../pages/JIFI/amazon-seller-config";
import WeeklySalesReport from "@pages/JIFI/weekly-sales/index.js";
import SaleStateReport from "@pages/JIFI/sale-state-report";
import TopBottomReport from "@pages/JIFI/top-bottom-report/index.js";
import CategoryPerformance from "@pages/JIFI/category-performance";
import NestedOrders from "@pages/JIFI/nested-orders/index.js"

import OrderReportPage from '@pages/JIFI/order-report/index.js'
import CorpUnfulfilledWarehouseOrdersPage from "@pages/JIFI/corp-orders/unfulfilled-warehouse";
import CorpSkuReport from "@pages/JIFI/reports/corp-sku-report";

import SOHDetails from "@pages/JIFI/demand/stock-on-hand-detail";
import StockAllocationPage from "@pages/JIFI/stock-allocation";
import FeatureFlagsPage from "@pages/JIFI/feature-flags/index.js";
import NestingRulesPage from "@pages/JIFI/nesting-rules/index.js";

const authProtectedRoutes = [
	{ path: "/orders/unfulfilled-warehouse", component: UnfulfilledWarehouseOrdersPage },
	{ path: "/orders/:orderID", component: OrderPage },
	{ path: "/order/create", component: OrderCreatePage },
	{ path: "/orders", component: OrdersAll },
	{ path: "/ip-logs/all", component: IpLogListPage },
	{ path: "/order-report", component: OrderReportPage },
	
	{ path: "/demand/stock-status", component: StockStatus },
	{ path: "/demand/stock-status-month", component: StockStatusMonth },
	{ path: "/demand/historic-stock-alocation", component: HistoricAllocation },

	{ path: "/demand/historic-stock-levels", component: HistoricStockLevels },

	{ path: "/corp-orders/unfulfilled-warehouse", component: CorpUnfulfilledWarehouseOrdersPage },
	{ path: "/corp-orders/:orderID", component: CorpOrder },
	{ path: "/corp-orders", component: CorpOrdersAll },

	{ path: "/reports/corp-sku", component: CorpSkuReport },

	{ path: "/returns/:returnID", component: Return },
	{ path: "/returns", compstockonent: AllReturns },

	// { path: "/external-personalisation", component: ExternalPers },
	{ path: "/external-personalisation-batches", component: ExternalPersBatches },

	// { path: "/external-personalisation-ewe", component: ExternalPersEWE },
	{ path: "/external-personalisation-batches-ewe", component: ExternalPersBatchesEWE },

	{ path: "/external-personalisation-batches-ewesyd", component: ExternalPersBatchesEWESYD },

	// { path: "/external-personalisation-airbox", component: ExternalPersAirbox },
	{ path: "/external-personalisation-batches-airbox", component: ExternalPersBatchesAirbox },

	// { path: "/external-personalisation-launch", component: ExternalPersLaunch },
	{ path: "/external-personalisation-batches-launch", component: ExternalPersBatchesLaunch },

	{ path: "/soh-details", component: SOHDetails},
	{ path: "/stock-allocation", component: StockAllocationPage},
	{ path: "/forecast-month-stock", component: ForecastMonthStock},
	{ path: "/weekly-sales", component: WeeklySalesReport},
	{ path: "/sale-state", component: SaleStateReport},
	{ path: "/top-bottom-report", component: TopBottomReport},
	{ path: "/category-performance", component: CategoryPerformance},
	// { path: "/analytics/stock-transfer-efficency", component: StockTransferEfficency },
	// { path: "/analytics/stock-over-time", component: StockOverTime },
	// { path: "/analytics/product-over-time", component: ProductOverTime },
	// { path: "/analytics/monogram-performance", component: MonogramPerformance },

	{ path: "/region-configs/list", component: RegionConfigsPage },
	{ path: "/region-configs/:regionId", component: RegionConfigDetail },
	{ path: "/amazon-seller-configs", component: AmazonSellerConfigsPage },

	{ path: "/carrier-performance", component: CarrierPerformanceList},
	{ path: "/shipment-analytic", component: ShipmentAnalytic},
	{ path: "/stock/inventory-accuracy", component: InventoryAccuracyPage},
	{ path: "/stock/stockout-report", component: StockoutReport},
	{ path: "/stock/transfer", component: TransferStockPage },
	{ path: "/stock/replenish", component: ReplenishStockPage },
	{ path: "/stock/return-to-warehouse", component: ReturnToWarehousePage },
	{ path: "/stock/warehouse-transfer", component: WarehouseTransferPage },
	{ path: "/nested-orders", component: NestedOrders },


	{ path: "/tracking-updates/:orderID/:trackingUpdateID", component: TrackingUpdatesPage },
	{ path: "/tracking-updates/:orderID", component: TrackingUpdatesPage },
	{ path: "/automations/view-reccomendations", component: Automations },
	{ path: "/automation-engine/rules/create", component: RuleBuilderPage },
	{ path: "/automation-engine/rules/:ruleId/edit", component: RuleBuilderPage },
	{ path: "/automation-engine", component: AutomationDashboardPage },

	{ path: "/factories/:factoryID", component: FactoryPage },
	{ path: "/factories", component: FactoryList },

	{ path: "/total-stock", component: TotalStockList },
	{ path: "/closing-soh", component: ClosingSohList },
	{ path: "/cogs", component: CogsRateList },
	{ path: "/cogs-holding", component: CogsHoldingList },
	{ path: "/cogs-breakdown", component: CogsBreakdown },
	{ path: "/container-timeline/:containerID", component: ContainerTimeline },
	{ path: "/container-timeline", component: ContainerTimeline },

	{ path: "/purchase-order/:purchaseOrderID", component: PurchaseOrderPage },
	{ path: "/purchase-order", component: PurchaseOrderList },
	
	{ path: "/order/bulk-send", component: BulkSendTo3PL },
	{ path: "/order/embossing", component: BulkSendEmbossing },
	{ path: "/awaiting-stock", component:  AwaitingStock},
	{ path: "/mispick-stock", component: MisPickStock},
	{ path: "/daily-orders", component: OrdersDaily },
	{ path: "/monograms", component: OrdersMonograms },
	{ path: "/products", component: Products },
	{ path: "/stock", component: Stock },
	{ path: "/approvals", component: Approvals },
	{ path: "/approval", component: ApprovalGroup },
	{ path: "/downloads", component: Downloads },
	{ path: "/pull", component: Pull },
	{ path: "/create-container", component: BookContainer },
	{ path: "/parcels", component: ParcelsPage },
	{ path: "/upcoming-container", component: UpcomingContainer },

	{ path: "/containers", component: ListContainer },

	{ path: "/container/edit/:containerID", component: EditContainer },
	{ path: "/container/:containerID", component: Container },
	
	{ path: "/transfer", component: Transfer },
	{ path: "/dashboard", component: Dashboard },
	{ path: "/profile", component: UserProfile },
	{ path: "/users/all", component: UserEdit },
	
	{ path: "/embroidery", component: Embroidery},
	{ path: "/print", component: Print},
	{ path: "/stock-movements/sku/:sku", component: SkuHistoryPage},
	{ path: "/movement-history", component: MovementPage},
	{ path: "/movement-history-enhanced", component: MovementPage},
	{ path: "/dual-inventory", component: DualInventoryPage},
	
	{ path: "/deliveries", component: Deliveries},
	{ path: "/delivery/:deliveryId", component: Delivery},
	{ path: "/deliveries-batch", component: DeliveryBatch},

	{ path: '/sku/all', component: SkuListPage},	
	{ path: "/location/all", component: AllLocations },
	{ path: "/error-logs/all", component: AllErrorLogs },
	{ path: "/error-logs/:id", component: ErrorLogDetail },
	{ path: "/location/edit/:locationID/hierarchy/assign", component: AssignSkuPage },
	{ path: "/location/edit/:locationID", component: EditLocations },
	
	{ path: "/location/new", component: EditLocations },

	{ path: "/feature-flags", component: FeatureFlagsPage },
	{ path: "/nesting-rules", component: NestingRulesPage },

	{ path: "/flagtype/all", component: AllFlagType },
	{ path: "/flagtype/edit/:flagTypeID", component: EditFlagType },
	{ path: "/flagtype/new", component: EditFlagType },

	
	{ path: "/variant-bulk-editor", component: VariantBulkEditor },
	{ path: "/variant/all", component: VariantListPage },
	{ path: "/product/all", component: AllProducts },
	{
		path: "/tickets",
		component: TicketsPage
	},
	{ path: "/product/edit/:productID/variant/edit/:variantID", component: EditVariant },
	{ path: "/product/edit/:productID/variant/new", component: EditVariant },
	{ path: "/product/edit/:productID", component: EditProducts },
	{ path: "/product/new", component: EditProducts },

	{ path: "/forecast/months", component: ForcastMonths},
	{ path: "/forecast", component: ForecastPage},

	{ path: "/po-overview", component: BasicTable},

	{ path: "/releases/:id", component: ReleasesSupplyChain},
	{ path: "/releases", component: ReleasesSupplyChainList},


	{ path: "/all-stock", component: AllStock},
	{ path: "/all-stock-new", component: AllStockNew},
	
	{ path: "/stock-warning", component: StockWarning},

	{ path: "/forward-print-labels", component:ForwardPrintLabels },
	{ path: "/cog", component: CogPage },

	{ path: "/eiz", component: EizConsignment},

	{path: "/notifications", component: NotificationListPage},

	{path: "/fulfillment/locations", component: FulFillmentLocationPage },

	{path: "/feedback", component:  FeedbackPage },

	{path: "/warranty-claim", component:  WarrantyClaimPage },

	{path: "/repair-ticket", component:  RepairTicket },
	{path: "/warranty-board", component:  WarrantyKanbanBoard },
	{path: "/ticket-dashboard/status-mappings", component: StatusMappingPage},
	{path: "/ticket-dashboard", component: TicketDashboardPage},
	

	{path: "/category/all", component: CategoryListPage},

	{path: "/category/new", component: CategoryPage},
	{path: "/category/edit/:categoryID", component: CategoryPage},

	{path: "/location-order-config", component: LocationOrderConfig},
	// this route should be at the end of all other routes
	{ path: "/", exact: true, component: () => <Redirect to="/dashboard" /> }
];

const publicRoutes = [
	{ path: "/logout", component: Logout },
	{ path: "/login", component: Login },
	{ path: "/forgot-password", component: ForgetPwd },
	{ path: "/register", component: Register },
	{ path : "/auth-lock-screen", component: LockScreen },

	{ path: "/maintenance", component: PagesMaintenance },
	{ path: "/comingsoon", component: PagesComingsoon },
	{ path: "/404", component: Pages404 },
	{ path: "/500", component: Pages500 },

	{ path: "/test-print", component: PrintTest },
	{ path: "/print-labels", component:PrintLabels }
	
];

export { authProtectedRoutes, publicRoutes };
